import React from 'react'
import { Image } from 'react-bootstrap'
import { parseHtml } from '../../../utils/common'
// import "./sharedcard.scss";

function SharedCard(props) {
  let baseUrl = process.env.NEXT_PUBLIC_REACT_APP_RESOURCE_BASE_URL
  let block = props.block

  return (
    <>
      <section className="startups-looking-section">
        <div className="startups-looking-inner">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-6 col-md-10 col-sm-10 startups-order-1">
                <div className="startups-looking-content">
                  <h2>{block.title}</h2>
                  {block.text ? parseHtml(block.text) : ''}
                </div>
              </div>
              <div className="col-lg-6 col-md-10 col-sm-10 startups-order-2">
                <div className="startups-looking-img">
                  <Image
                    src={
                      block?.image.data
                        ? `${baseUrl}${block?.image.data?.attributes.url}`
                        : ''
                    }
                    alt={
                      block?.image.data
                        ? `${block?.image.data?.attributes.alternativeText}`
                        : ''
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default SharedCard
